module.exports = __webpack_public_path__ + "img/img_4.a1e105e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/img_4.png
// module id = mVIF
// module chunks = 1